import { render, staticRenderFns } from "./OptionAction.vue?vue&type=template&id=02edd2c8&scoped=true"
import script from "./OptionAction.vue?vue&type=script&lang=js"
export * from "./OptionAction.vue?vue&type=script&lang=js"
import style0 from "./OptionAction.vue?vue&type=style&index=0&id=02edd2c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02edd2c8",
  null
  
)

export default component.exports